export default __webpack_public_path__ + "static/media/Mobile-Tablet-Monitor-Display.c382ced5.png";